module.exports = __webpack_public_path__ + "img/90.77bb819c.jpg";